import { dataCurveSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCurveSquareSolid = /*#__PURE__*/createIcon(dataCurveSquareSolid)
export default IconCurveSquareSolid
